/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/CloseAction",
  isSubmitting
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let stepsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'steps',
})
  return (<React.Fragment
>
<TysiaModalHeaderCloseAction
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../../../SetupAutomations/No'))}
 data="steps"
 disabled={stepsIsSubmittingData}
/>
{children}
</React.Fragment>)
}